import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  padding: 0 20px 80px 20px;
  position: relative;
  min-width: 1140px;
`;

export const HeaderContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: start;
  align-items: start;
`;

export const TabContainer = styled.div`
  box-sizing: border-box;
  padding: 0 24px;
  width: 100%;
  height: 40px;
  align-items: center;
  display: flex;
  gap: 20px;
  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const TabItem = styled.div<{ selected: boolean }>`
  display: flex;
  flex-direction: column;
  ${(props) => props.selected && "border-bottom: 2px solid var(--alias-color-primary-normal);"}
  box-sizing: border-box;
  height: 40px;
  padding: 8px 12px;
  align-content: center;
  cursor: pointer;
`;

export const ContentContainer = styled.div`
  box-sizing: border-box;
  padding: 0px 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 20px;
  height: 38px;
`;

export const TableContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
